<div
  class="map-controls absolute m-2 leaflet-top leaflet-right flex flex-column gap-1 text-xs align-items-start">
  <a
    (click)="zoomIn()"
    class="pointer-events-auto p-button p-button-raised p-button-icon-only p-button-rounded p-button-xs p-button-primary"
    ><span class="fas fa-plus"></span
  ></a>
  <a
    (click)="zoomOut()"
    class="pointer-events-auto p-button p-button-raised p-button-icon-only p-button-rounded p-button-xs p-button-primary"
    ><span class="fas fa-minus"></span
  ></a>
  <a
    (click)="centerMap()"
    class="pointer-events-auto p-button p-button-raised p-button-icon-only p-button-rounded p-button-xs p-button-primary"
    ><span class="fas fa-arrows-to-dot"></span
  ></a>
  <a
    (click)="openPoiSwitch()"
    class="pointer-events-auto p-button p-button-raised p-button-icon-only p-button-rounded p-button-xs p-button-primary"
    ><span class="fas fa-map-location-dot"></span
  ></a>
</div>

@if (mapStore.featureHighlight(); as featureInfo) {
  <div
    [class]="mapTooltipPosition"
    class="map-tooltip m-2 mb-6 p-2 p-card flex flex-column gap-1 text-xs align-items-start">
    <div>
      <strong>{{ featureInfo.feature.properties.name }} </strong>
      <span>
        ({{
          featureInfo.feature.properties.key ||
            featureInfo.feature.properties.gkz
        }})</span
      >
    </div>
    @if (featureInfo.indicator) {
      <span>{{ featureInfo.indicator.name }}</span>
    }
    @if (featureInfo.value !== null && featureInfo.value !== undefined) {
      <span
        >Wert:
        {{
          featureInfo.value | safeNumber: featureInfo.indicator?._id : false
        }}</span
      >
    }
  </div>
}

<div
  [class]="mapStyleClass"
  class="map-widget"
  #chartComp
  [id]="mapId"
  style="height: 100%; width: 100%; overflow: hidden"></div>
